<template>
  <div class="k-tag-container">
    <div class="k-tag-box-text">
      <h1> {{ `Razão Social: ${data.nomerazao}` }}</h1>
      <h2> {{ `CPF/CNPJ: ${data.cpfcnpj}` }}</h2>
    </div>
    <div class="icon-feather-container" @click="$emit('closektag', data)">
      <feather type="x" size="13px" />
    </div>
  </div>
</template>

<script>
export default {
	props: {
		data: {
			type: Object,
			default: () => {},
		},
	},
};
</script>

<style scoped>
  .k-tag-box-text {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    color: #ffffff;
    font-size: 11px;
  }
  .k-tag-container {
    width: 100%;
    display: flex;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 15px;
    padding-right: 20px;
    border-radius: 30px;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    background-color: #7957d5;
    transition: 0.3s ease-in-out;
  }
  .icon-feather-container {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background-color: hsla(0,0%,4%,.2);
    padding: 3px;
    border-radius: 50%;
    cursor: pointer;
    transition: 0.2s ease-in;
  }

    .icon-feather-container:hover {
        background-color: rgba(10, 10, 10, 0.39);
    }

</style>
